import React from "react";

const VARIANTS = {
  default: "bg-white/5 text-zinc-300 border border-white/10",
  gold: "bg-gold/10 text-gold border border-gold/25",
  success: "bg-emerald-500/10 text-emerald-300 border border-emerald-500/25",
  warn: "bg-amber-500/10 text-amber-300 border border-amber-500/25",
  danger: "bg-red-500/10 text-red-300 border border-red-500/25",
  info: "bg-sky-500/10 text-sky-300 border border-sky-500/25",
  outline: "bg-transparent text-zinc-400 border border-white/10",
};

const SIZES = {
  xs: "text-[10px] px-2 py-0.5",
  sm: "text-[11px] px-2.5 py-0.5",
  md: "text-xs px-3 py-1",
};

export function Badge({
  variant = "default",
  size = "sm",
  className = "",
  icon: Icon,
  children,
  uppercase = false,
  ...props
}) {
  const base = `inline-flex items-center gap-1.5 rounded-full font-medium ${uppercase ? "uppercase tracking-widest" : ""}`;
  return (
    <span className={`${base} ${VARIANTS[variant] || VARIANTS.default} ${SIZES[size] || SIZES.sm} ${className}`} {...props}>
      {Icon && <Icon className="w-3 h-3" strokeWidth={2} />}
      {children}
    </span>
  );
}

export default Badge;
